// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"273":"8a41ab8e","546":"8a41ab8e","576":"8a41ab8e","818":"8a41ab8e","918":"17937ec7","936":"8a41ab8e","967":"8a41ab8e"}[chunkId] + ".chunk.css";
};